import { useNavigate } from "react-router-dom";
import classes from "./PurchaseOptions.module.css";


const PaymentCancelled = ({}) => {

  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center mt-5">
      <div className={`d-flex flex-column align-items-center ${classes.boxedContainer}`}>
        <img src="/icons/cancel-icon.svg" alt="Cancelled" />
        <p>
          Your purchase for Challenge account failed!
        </p>
        <span onClick={() => navigate("/trading")} role="button" tabIndex={0}>
          Back to home
        </span>
      </div>
    </div>
  )
};

export default PaymentCancelled;